import React, { useState, useRef, useLayoutEffect } from 'react';

import useCloseOnOutsideClick from 'utils/hooks/useCloseOnOutsideClick';
import useIsUserAuthenticated from 'utils/hooks/useIsUserAuthenticated';
import Button from 'components/Buttons/Button';
import LoadingZone from 'components/LoadingZone';
import ThumbsUpThumbsDownFeedback from './ThumbsUpThumbsDownFeedback';
import TextFeedbackForm from './TextFeedbackForm';
import usePostFeedback from './usePostFeedback';

const Feedback = () => {
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
  const [isTextFormOpen, setIsTextFormOpen] = useState(false);
  const feedbackRef = useRef();
  const { bIsLoading } = usePostFeedback();
  const bIsUserAuthenticated = useIsUserAuthenticated();

  const handleReset = () => {
    setIsFeedbackOpen(false);
    setIsTextFormOpen(false);
  };

  useCloseOnOutsideClick(feedbackRef, handleReset, isFeedbackOpen);

  // Scroll down to show whole form
  useLayoutEffect(() => {
    if (isFeedbackOpen) {
      feedbackRef.current.scrollIntoView({
        block: 'nearest',
        behavior: 'smooth',
      });
    }
  });

  return (
    <div className='feedback' ref={feedbackRef}>
      {isFeedbackOpen ? (
        <LoadingZone isLoading={bIsLoading}>
          <div className='feedback__content'>
            {!bIsUserAuthenticated || isTextFormOpen ? (
              <TextFeedbackForm />
            ) : (
              <>
                <ThumbsUpThumbsDownFeedback />
                <Button
                  sFlavor='underline'
                  fnHandleClick={() => setIsTextFormOpen(true)}
                  className='feedback__addNoteTrigger'
                >
                  Have anything else to share?
                </Button>
              </>
            )}
          </div>
        </LoadingZone>
      ) : (
        <Button
          sFlavor='tertiary'
          fnHandleClick={() => setIsFeedbackOpen(true)}
        >
          Feedback
        </Button>
      )}
    </div>
  );
};

export default Feedback;
